import React from 'react';
import { withStyles, Chip, TableCell, TableRow } from '@material-ui/core';
import { Validate } from '../../../other';
import { useSelector } from 'react-redux';

const ProductRow_ = (props) => {
  const { classes, product_name, category_name, stock_element, index } = props;
  const idCountry = useSelector((state) => state.tienda.Country_idCountry);

  const attributes = stock_element.valoratributo.map((attribute, index) => (
    <Chip
      key={index}
      label={`${attribute.key}: ${attribute.value}`}
      className={classes.chip_style}
      variant="outlined"
    />
  ));

  const infinity_icon = (
    <svg
      width="14"
      height="9"
      viewBox="0 0 14 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.65625 4.37695V4.2334C0.65625 3.71387 0.736003 3.22624 0.895508 2.77051C1.05957 2.31478 1.29199 1.91374 1.59277 1.56738C1.89811 1.22103 2.2627 0.952148 2.68652 0.760742C3.11491 0.564779 3.59115 0.466797 4.11523 0.466797C4.59831 0.466797 5.02669 0.553385 5.40039 0.726562C5.77865 0.89974 6.10905 1.1276 6.3916 1.41016C6.67415 1.69271 6.91341 1.99805 7.10938 2.32617C7.30534 2.6543 7.46712 2.98014 7.59473 3.30371C7.72233 3.62728 7.82031 3.91211 7.88867 4.1582V4.37695C7.82031 4.62305 7.72233 4.91016 7.59473 5.23828C7.46712 5.56641 7.30534 5.89909 7.10938 6.23633C6.91341 6.57357 6.67415 6.88802 6.3916 7.17969C6.11361 7.4668 5.78776 7.69922 5.41406 7.87695C5.04036 8.05013 4.61198 8.13672 4.12891 8.13672C3.60026 8.13672 3.12174 8.04102 2.69336 7.84961C2.26497 7.65365 1.89811 7.38249 1.59277 7.03613C1.29199 6.68978 1.05957 6.29102 0.895508 5.83984C0.736003 5.38411 0.65625 4.89648 0.65625 4.37695ZM2.42676 4.2334V4.37695C2.42676 4.70052 2.46549 5.0013 2.54297 5.2793C2.62044 5.55729 2.73438 5.80111 2.88477 6.01074C3.03516 6.22038 3.22201 6.38444 3.44531 6.50293C3.66862 6.62142 3.92383 6.68066 4.21094 6.68066C4.49805 6.68066 4.75326 6.61686 4.97656 6.48926C5.19987 6.3571 5.39583 6.19303 5.56445 5.99707C5.73763 5.79655 5.87891 5.58919 5.98828 5.375C6.10221 5.16081 6.19108 4.96257 6.25488 4.78027C6.31868 4.59798 6.35742 4.46354 6.37109 4.37695V4.1582C6.35742 4.07617 6.31868 3.94857 6.25488 3.77539C6.19108 3.59766 6.10221 3.40397 5.98828 3.19434C5.87891 2.9847 5.73991 2.78418 5.57129 2.59277C5.40267 2.39681 5.20443 2.2373 4.97656 2.11426C4.7487 1.99121 4.48893 1.92969 4.19727 1.92969C3.91471 1.92969 3.66178 1.99121 3.43848 2.11426C3.21973 2.23275 3.03516 2.39681 2.88477 2.60645C2.73438 2.81608 2.62044 3.06217 2.54297 3.34473C2.46549 3.62272 2.42676 3.91895 2.42676 4.2334ZM13.9316 4.2334V4.37695C13.9316 4.89648 13.8496 5.38411 13.6855 5.83984C13.526 6.29102 13.2936 6.68978 12.9883 7.03613C12.6875 7.38249 12.3229 7.65365 11.8945 7.84961C11.4661 8.04102 10.9876 8.13672 10.459 8.13672C9.97591 8.13672 9.54753 8.05013 9.17383 7.87695C8.80013 7.69922 8.47201 7.4668 8.18945 7.17969C7.91146 6.88802 7.6722 6.57357 7.47168 6.23633C7.27572 5.89909 7.11393 5.56641 6.98633 5.23828C6.86328 4.91016 6.76758 4.62305 6.69922 4.37695V4.1582C6.76758 3.91211 6.86556 3.62728 6.99316 3.30371C7.12077 2.98014 7.28255 2.6543 7.47852 2.32617C7.67904 1.99805 7.91829 1.69271 8.19629 1.41016C8.47884 1.1276 8.80697 0.89974 9.18066 0.726562C9.55892 0.553385 9.98958 0.466797 10.4727 0.466797C11.0013 0.466797 11.4775 0.564779 11.9014 0.760742C12.3298 0.952148 12.6943 1.22103 12.9951 1.56738C13.3005 1.91374 13.5329 2.31478 13.6924 2.77051C13.8519 3.22624 13.9316 3.71387 13.9316 4.2334ZM12.1611 4.37695V4.2334C12.1611 3.91895 12.1224 3.62272 12.0449 3.34473C11.9674 3.06217 11.8535 2.81608 11.7031 2.60645C11.5527 2.39681 11.3659 2.23275 11.1426 2.11426C10.9238 1.99121 10.6732 1.92969 10.3906 1.92969C10.099 1.92969 9.83919 1.99121 9.61133 2.11426C9.38346 2.2373 9.18522 2.39681 9.0166 2.59277C8.84798 2.78418 8.70671 2.9847 8.59277 3.19434C8.47884 3.40397 8.38997 3.59766 8.32617 3.77539C8.26693 3.94857 8.22819 4.07617 8.20996 4.1582V4.37695C8.22819 4.46354 8.26693 4.59798 8.32617 4.78027C8.38997 4.96257 8.47884 5.16081 8.59277 5.375C8.71126 5.58919 8.85254 5.79655 9.0166 5.99707C9.18522 6.19303 9.38118 6.3571 9.60449 6.48926C9.83236 6.61686 10.0898 6.68066 10.377 6.68066C10.6595 6.68066 10.9124 6.62142 11.1357 6.50293C11.359 6.38444 11.5459 6.22038 11.6963 6.01074C11.8512 5.80111 11.9674 5.55729 12.0449 5.2793C12.1224 5.0013 12.1611 4.70052 12.1611 4.37695Z"
        fill="#242424"
      />
    </svg>
  );

  const stock_product =
    stock_element.s_ilimitado === 1 ? infinity_icon : stock_element.s_cantidad;
  const price = stock_element.s_precio
    ? '$' + Validate.number_format(stock_element.s_precio, idCountry)
    : '-';
  const offer_price =
    stock_element.s_precio_oferta > 0
      ? '$' + Validate.number_format(stock_element.s_precio_oferta, idCountry)
      : '-';
  const wholesale_price =
    stock_element.s_precio_mayorista > 0
      ? '$' +
        Validate.number_format(stock_element.s_precio_mayorista, idCountry)
      : '-';

  return (
    <TableRow>
      <TableCell className={classes.table_value}>
        {index === 0 ? product_name : ''}
      </TableCell>
      <TableCell className={classes.table_attributes}>
        <div className={classes.chip_container}>{attributes}</div>
      </TableCell>
      <TableCell className={classes.table_value}>{stock_product}</TableCell>
      <TableCell className={classes.table_value}>{price}</TableCell>
      <TableCell className={classes.table_value}>{offer_price}</TableCell>
      <TableCell className={classes.table_value}>{wholesale_price}</TableCell>
      <TableCell className={classes.table_value}>{category_name}</TableCell>
      <TableCell className={classes.table_sizes}>
        {stock_element.s_alto}cm x {stock_element.s_ancho}cm x{' '}
        {stock_element.s_profundidad}cm, {stock_element.s_peso}kg
      </TableCell>
    </TableRow>
  );
};

const styles = (theme) => ({
  chip_container: {
    marginTop: '5px',
    display: 'flex',
  },
  chip_style: {
    border: '1px solid #53B755',
    margin: '5px',
  },
  table_value: {
    border: 'none',
    fontWeight: '600',
    fontSize: '0.87rem',
    lineHeight: '16px',
    color: '#242424',
    whiteSpace: 'nowrap',
  },
  table_attributes: {
    border: 'none',
    fontWeight: '600',
    fontSize: '0.87rem',
    lineHeight: '16px',
    color: '#242424',
  },
  table_sizes: {
    border: 'none',
    fontWeight: '600',
    fontSize: '0.87rem',
    lineHeight: '16px',
    color: '#242424',
    whiteSpace: 'nowrap',
  },
});

export const ProductRow = withStyles(styles)(ProductRow_);
